import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import { IMerchantAccount } from '../../../../../interfaces/IMerchantAccount';

export interface IEditUserHeader {
    user: IMerchantAccount;
}

const useStyles = makeStyles({
    root: {

    },
    header: {
        fontSize: "1.25rem",
        fontWeight: 600,
    },
    pill: {
        marginLeft: "0.75rem",
        padding: "0.5rem",
        backgroundColor: "#F3F4F9",
        fontSize: "0.8rem",
        fontWeight: 500,
        color: "#455681",
        borderRadius: "1rem"
    },
    email: {
        fontWeight: 400,
        fontSize: "1.1rem"
    }
})

const EditUserHeader = ({user}: IEditUserHeader ) => {
    
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div className={classes.root}>
            <h2 className={classes.header}>
                {user.first_name} {user.last_name}
                {
                    user.superuser && <span className={classes.pill} >{t("userManagement.form.yoelloStaff")}</span>
                }
            </h2>

            <p className={classes.email}>{user.contact_email}</p>
        </div>
    )
}

export default EditUserHeader;